import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-list-overview',
  templateUrl: './event-list-overview.component.html',
  styleUrls: ['./event-list-overview.component.css']
})
export class EventListOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
